/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Oscari_S3Inputs */

const en_tut_oscari_s3 = /** @type {(inputs: Tut_Oscari_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`From a person result you can go straight to **Temukan**, **Sapa**, or **Pesan**.`)
};

const id_tut_oscari_s3 = /** @type {(inputs: Tut_Oscari_S3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dari hasil orang, Anda bisa langsung **Temukan**, **Sapa**, atau kirim **Pesan**.`)
};

/**
* | output |
* | --- |
* | "From a person result you can go straight to **Temukan**, **Sapa**, or **Pesan**." |
*
* @param {Tut_Oscari_S3Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_oscari_s3 = /** @type {((inputs?: Tut_Oscari_S3Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Oscari_S3Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_oscari_s3(inputs)
	return en_tut_oscari_s3(inputs)
});